<script setup lang="ts">
  import type { FooterColumn } from '~/types';

  withDefaults(
    defineProps<{
      showLinks?: boolean;
    }>(),
    {
      showLinks: false,
    },
  );

  const columns: FooterColumn[] = [
    {
      title: 'Atendimento',
      orientation: 'vertical',
      links: [
        {
          label: 'Acompanhar pedido',
          href: 'https://app.solarinove.com.br/orders',
        },
      ],
    },
    {
      title: 'Como trabalhamos',
      orientation: 'vertical',
      links: [
        {
          label: 'Política de privacidade',
          href: 'https://landing.solfacil.com.br/politica-de-privacidade/',
        },
        {
          label: 'Termos e condições',
          href: 'https://loja.solfacil.com.br/terms',
        },
      ],
    },
    {
      title: 'Nossos serviços',
      orientation: 'vertical',
      links: [
        {
          label: 'Financiamento Solfácil',
          href: 'https://solfacil.com.br/financie/',
        },
        {
          label: 'Ampera',
          href: 'https://solfacil.com.br/ampera/',
        },
        {
          label: 'Seja um integrador',
          href: 'https://solfacil.com.br/solucoes/',
        },
      ],
    },
    {
      title: 'Institucional',
      orientation: 'vertical',
      links: [
        {
          label: 'Sobre a Solfácil',
          href: 'https://solfacil.com.br/',
        },
        {
          label: 'Trabalhe conosco',
          href: 'https://solfacil.com.br/trabalhe-conosco/',
        },
        {
          label: 'Blog',
          href: 'https://blog.solfacil.com.br/',
        },
        {
          label: 'Solfácil Mais',
          href: 'https://solfacilmais.solfacil.com.br/',
        },
        {
          label: 'Radar Solfácil',
          href: 'https://lp.solfacil.com.br/radar-solfacil',
        },
      ],
    },
    {
      title: 'Siga nossas redes',
      orientation: 'horizontal',
      links: [
        {
          icon: '/icons/instagram.svg',
          href: 'https://www.instagram.com/solfacil/',
        },
        {
          icon: '/icons/linkedin.svg',
          href: 'https://www.linkedin.com/company/solfacil/',
        },
      ],
    },
  ];
</script>

<template>
  <div class="store-app-footer">
    <div v-if="showLinks" class="footer-content">
      <template v-for="(column, i) in columns" :key="i">
        <div class="column">
          <span class="title">
            {{ column.title }}
          </span>
          <div
            class="links"
            :class="{ icon: column.orientation === 'horizontal' }">
            <template v-for="(link, j) in column.links" :key="j">
              <a
                v-if="link.label"
                class="link"
                :href="link.href"
                :alt="link.label || link.icon">
                {{ link.label }}
              </a>
              <a
                v-else
                class="link"
                :href="link.href"
                :alt="link.label || link.icon">
                <img
                  :src="link.icon"
                  :alt="link.label || link.icon"
                  width="48"
                  height="48" />
              </a>
            </template>
          </div>
        </div>
      </template>
    </div>
    <FooterCopyright />
  </div>
</template>

<style lang="scss">
  @mixin site-container {
    @apply w-full md:site:max-w-[1440px];
    @apply md:site:mx-auto;
  }

  .store-app-footer {
    @apply w-full flex flex-col;
    @apply bg-neutral-high-light;

    > .footer-content {
      @apply flex flex-col md:site:flex-row gap-xs md:site:justify-between;
      @apply px-micro md:site:px-2xs py-sm md:site:py-md;
      @include site-container;

      > .column {
        @apply flex flex-col gap-y-4xs;

        > .title {
          @apply fonts-heading-h4;
          @apply text-neutral-low-dark;

          @media (min-width: 1024px) {
            font-size: 20px;
            font-weight: 500;
            font-family: 'Grotesk', sans-serif;
            line-height: 1.15;
          }
        }

        > .links {
          @apply flex flex-col gap-4xs;

          &.icon {
            @apply flex-row;
          }

          > .link {
            @apply fonts-body-medium-regular;
            @apply text-neutral-low-medium;

            &:hover {
              @apply text-neutral-low-dark;
            }
          }
        }
      }
    }
  }
</style>
